<style scoped>
@import "./index.css";
</style>

<template>
    <div id="layout-container-hui">
        <Row class-name="tf-row">
            <!--<Col :md="8" :xs="24">-->
                <!--<Card id="myCard" :bordered="false" :dis-hover="true">-->
                    <!--<div class="myCard-head" slot="title">-->
                        <!--<span class="myCard-title">基本设置</span>-->
                    <!--</div>-->
                    <!--<div class="myCard-con web-gailan overview">-->
                        <!--<dl class="tf-cell">-->
                            <!--<dd>-->
                                <!--<span>消息推送声音</span>-->
                                <!--<i-switch v-model="soundSwitch"  @on-change="soundChange" />-->
                            <!--</dd>-->
                            <!--<dd>-->
                                <!--<span>消息通知</span>-->
                                <!--<i-switch v-model="messageSwitch" @on-change="messageChange" />-->
                            <!--</dd>-->
                        <!--</dl>-->
                    <!--</div>-->
                <!--</Card>-->
            <!--</Col>-->
            <Col :md="8" :xs="24">
                <Card id="myCard" :bordered="false" :dis-hover="true">
                    <div class="myCard-head" slot="title">
                        <span class="myCard-title">个人资料</span>
                    </div>
                    <div class="myCard-con web-gailan overview">
                        <myInfo></myInfo>
                    </div>
                </Card>
            </Col>
            <Col :md="8" :xs="24">
                <Card id="myCard" :bordered="false" :dis-hover="true">
                    <div class="myCard-head" slot="title">
                        <span class="myCard-title">修改密码</span>
                    </div>
                    <div class="myCard-con web-gailan overview">
                        <setPassword></setPassword>
                    </div>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
import setPassword from "./setpassword";
import myInfo from "./myinfo";
export default {
    components: {
        setPassword,
        myInfo
    },
    data() {
        return {
            user:[],
            soundSwitch  : false,
            messageSwitch: false
        }
    },
    computed: {
        //接收socket消息
        wsMessage() {
            return this.$store.state.app.wsMessage;
        }
    },
    watch:{
        //监控并且格式化socket消息
        wsMessage(e){
            const that = this;
            if(that.user.length > 0){
                that.user.map(function(vo,index){
                    if(vo.emac == e.emac) {
                        that.user.splice(index,1,e);
                    }else{
                        that.user.push(e);
                    }
                })
            }else{
                that.user.push(e);
            }
        }
    },
    created() {
        if(this.$func.data.get('soundSwitch')){
            this.soundSwitch = this.$func.data.get('soundSwitch')   == 'true' ? true : false;
        }
        if(this.$func.data.get('messageSwitch')){
            this.messageSwitch = this.$func.data.get('messageSwitch') == 'true' ? true : false;
        }
    },
    methods: {
        soundChange(status){
            this.soundSwitch = status;
            this.$func.data.set('soundSwitch',status)
        },
        messageChange(status){
            this.messageSwitch = status;
            this.$func.data.set('messageSwitch',status)
        }
    }
};
</script>
